/**
 * Filters for the admin mailing list query
 */
export interface MailingListFilters {
  languages?: string[];
  packs?: string[];
  registeredAfter?: Date;
  registeredBefore?: Date;
  lastLoginAfter?: Date;
  lastLoginBefore?: Date;
  includeOptedOut?: boolean;
  adminsOnly?: boolean;
}

/**
 * Entry returned by the mailing list API
 */
export interface MailingListEntry {
  email: string;
  firstName: string;
  lastName: string;
  companyName: string;
  pack: string;
  preferredLanguage: string;
  lastLogin: string | null;
  registeredAt: string;
  marketingOptOut: boolean;
  userRole: string;
}

/**
 * Response from the mailing list API
 */
export interface MailingListResponse {
  data: MailingListEntry[];
  count: number;
}

/**
 * Export format options
 */
export type ExportFormat = 'semicolon' | 'newline' | 'comma';

/**
 * Language options for filters
 */
export const LANGUAGE_OPTIONS = [
  { label: 'French', value: 'fr' },
  { label: 'English', value: 'en' },
  { label: 'German', value: 'de' },
  { label: 'Dutch', value: 'nl' },
];
